import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { scrollTo } from "@/components/Reveal";

/** Thumb-reachable Apply CTA for phones. Appears after the hero, hides while the form itself is on screen. */
export default function StickyApply() {
  const [pastHero, setPastHero] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const form = document.querySelector("#apply");
    let observer = null;
    if (form && "IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => setFormVisible(entries.some((e) => e.isIntersecting)), { threshold: 0.1 });
      observer.observe(form);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);

  const show = pastHero && !formVisible;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-black/75 px-4 pb-[max(env(safe-area-inset-bottom),12px)] pt-3 backdrop-blur-xl md:hidden"
          data-testid="sticky-apply-bar"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
              <p className="truncate text-[10px] font-semibold uppercase tracking-[0.25em] text-neutral-400">Private 1-on-1 coaching</p>
              <p className="truncate font-serif text-sm italic text-neutral-300">Applications are open.</p>
            </div>
            <button
              onClick={() => scrollTo("#apply")}
              data-testid="sticky-apply-btn"
              className="flex shrink-0 items-center gap-2 bg-white px-5 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-black transition-colors duration-300 active:bg-neutral-300"
            >
              Apply Now <ArrowDown className="h-3.5 w-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
